import { render, staticRenderFns } from "./skill.component.html?vue&type=template&id=bcc39aa4&scoped=true&"
import script from "./skill.component.ts?vue&type=script&lang=ts&"
export * from "./skill.component.ts?vue&type=script&lang=ts&"
import style0 from "./skill.component.scss?vue&type=style&index=0&id=bcc39aa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc39aa4",
  null
  
)

export default component.exports